import { nextTick } from 'vue';
import { createRouter, createWebHistory, } from 'vue-router';
import { i18n } from '@/locales';
import { convertCase } from '@/utils';
import { routeName } from '@/constants/routeName';
import store from '@/vuex-store';
// 미들웨어
import { login as loginMiddleware, auth, } from '@/router-middleware';
// Components
import MainLayout from '@/views/MainLayout.vue';
import DesktopLogin from '@/views/DesktopLogin.vue';
import Health from '@/views/Health.vue';
import NotFound from '@/views/NotFound.vue';
// 이하 실제 메뉴 리스트
import welcome from '@/router/welcome';
import barogoNotice from '@/router/barogo-notice';
import memberCompanyInquiry from '@/router/member-company-inquiry';
import distributorNotice from '@/router/distributor-notice';
import storeWorkProcess from '@/router/store-work-process';
import workerNotice from '@/router/worker-notice';
import requestMap from '@/router/request-map';
import ReportDownload from '@/router/report-download';
import BaromoneyTransferSetting from '@/router/baromoney-transfer-setting';
import BaromoneyAccountReceivableList from '@/router/baromoney-account-receivable-list';
import BaromoneyAccruedExpensesList from '@/router/baromoney-accrued-expenses-list';
import operationSetting from '@/router/operation-setting';
import storeAdjustment from '@/router/store-adjustment';
import deliveryHistory from '@/router/delivery-history';
import storeManagement from '@/router/store-management';
import hubManagement from '@/router/hub-management';
import hubAdjustment from '@/router/hub-adjustment';
import workerManagement from '@/router/worker-management';
import workerAdjustment from '@/router/worker-adjustment';
import workerBaromoneyHistory from '@/router/worker-baromoney-history';
import workerProfit from '@/router/worker-profit';
import workerMonthlyAttendance from '@/router/worker-monthly-attendance';
import baromoneyReport from '@/router/baromoney-report';
import mapControl from '@/router/map-control';
import listControl from '@/router/list-control';
import userManagement from '@/router/user-management';
import shareManagement from '@/router/share-management';
import deliveryChargeAreaControl from '@/router/delivery-charge-area-control';
import workerAllocateDialog from '@/router/worker-allocate-dialog';
import locationControl from '@/router/location-control';
import storeStats from '@/router/store-stats';
import hubStats from '@/router/hub-stats';
import sales from '@/router/sales';
// 이하 개발용
import designSystem from '@/router/design-system';
import temporary from '@/router/temporary';
import routerEnhancer from '@/router-middleware/router-enhancer';
import withdrawalRequest from '@/router/withdrawal-request';
import workerDetail from './worker-detail';
const routeList = [
    // 로그인이 필요한 라우트
    {
        path: '/',
        meta: {
            middleware: auth,
        },
        redirect: {
            name: routeName.WELCOME,
        },
        component: MainLayout,
        children: [
            ...welcome,
            ...barogoNotice,
            ...memberCompanyInquiry,
            ...distributorNotice,
            ...storeWorkProcess,
            ...workerNotice,
            ...requestMap,
            ...ReportDownload,
            ...BaromoneyTransferSetting,
            ...BaromoneyAccountReceivableList,
            ...BaromoneyAccruedExpensesList,
            ...operationSetting,
            ...deliveryHistory,
            ...listControl,
            ...storeAdjustment,
            ...storeManagement,
            ...hubManagement,
            ...hubAdjustment,
            ...workerManagement,
            ...workerBaromoneyHistory,
            ...workerProfit,
            ...workerMonthlyAttendance,
            ...workerAdjustment,
            ...sales,
            ...baromoneyReport,
            ...userManagement,
            ...shareManagement,
            ...deliveryChargeAreaControl,
            ...storeStats,
            ...hubStats,
            // 이하 테스트 라우터. 이 위로 추가
            ...designSystem,
            ...temporary,
        ],
    },
    // 이하 토큰 로그인 허용 라우트
    mapControl,
    locationControl,
    workerAllocateDialog,
    withdrawalRequest,
    workerDetail,
    // 이하 로그인이 필요 없는 라우트
    {
        path: '/login',
        name: routeName.LOGIN,
        component: DesktopLogin,
        meta: {
            middleware: loginMiddleware,
        },
    },
    {
        path: '/healthz',
        name: 'Health',
        component: Health,
    },
    {
        path: '/:catchAll(.*)',
        name: 'NotFound',
        component: NotFound,
    },
];
const router = createRouter({
    history: createWebHistory(),
    routes: routeList,
});
router.beforeEach(routerEnhancer);
const lc = 'views.head_tag_title.';
router.afterEach((to) => {
    // 0. currentPage 작업 : 헤드컨트롤러 타이틀을 위한 값
    // matched.at(-2)의 name이 존재하면 해당 name에 속한 탭 페이지를 의미함. (상점정산 디테일은 상점정산 라우트의 자녀가 아니기 때문)
    // currentPage 값은 라이더 정산의 이행상황신고와 같이 탭인 경우 그 상위 값(라이더 정산), 그 외의 경우 해당 페이지 값.
    const currentPageName = to.matched.at(-2)?.name ?? to.name;
    store.dispatch('app/setCurrentPageName', currentPageName);
    // 1. 브라우저 탭에서 쓰이느 headTagTitle 작업 : LNB + (메인, 지도관제)에 대응
    const headTagTitle = to.matched.at(-1)?.path.split('/')[1];
    nextTick(() => {
        document.title = `${i18n.t(lc + convertCase(headTagTitle, 'kebab', 'snake'))} | ${i18n.t(`${lc}app`)}`;
    });
});
export default router;
